(function () {
  var COOKIE_KEY = 'lien_exit_popup_shown';
  var COOKIE_DAYS = 7;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  function openPopup() {
    var popup = document.getElementById('lien-exit-popup');
    if (!popup) return;
    popup.classList.add('is-open');
    popup.removeAttribute('aria-hidden');
    setCookie(COOKIE_KEY, '1', COOKIE_DAYS);
  }

  function closePopup() {
    var popup = document.getElementById('lien-exit-popup');
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  function init() {
    if (getCookie(COOKIE_KEY)) return;

    var popup = document.getElementById('lien-exit-popup');
    if (!popup) return;

    // Desktop: mouseleave event
    document.addEventListener('mouseleave', function handler(e) {
      if (e.clientY <= 0) {
        openPopup();
        document.removeEventListener('mouseleave', handler);
      }
    });

    // Mobile: 15 saniye hareketsizlik
    var mobileTimer;
    function resetTimer() {
      clearTimeout(mobileTimer);
      mobileTimer = setTimeout(openPopup, 15000);
    }
    ['touchstart', 'touchmove', 'scroll'].forEach(function (ev) {
      document.addEventListener(ev, resetTimer, { passive: true });
    });
    resetTimer();

    // Kapatma
    popup.querySelector('.lien-popup__close')?.addEventListener('click', closePopup);
    popup.querySelector('.lien-popup__overlay')?.addEventListener('click', closePopup);

    // Form submit — submit to Shopify customer form, show inline success
    document.getElementById('lien-popup-form')?.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = this;
      var btn = form.querySelector('.lien-popup__btn');
      var email = form.querySelector('input[type="email"]')?.value;
      if (!email) return;
      if (btn) { btn.classList.add('lien-popup__btn--loading'); btn.textContent = 'Gönderiliyor…'; }
      var fd = new FormData(form);
      fetch('/contact#contact_form', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      }).catch(function () { /* network error — still show success UX since Shopify retries server-side */ })
        .finally(function () {
          var success = document.querySelector('.lien-popup__success');
          if (success) success.hidden = false;
          form.style.display = 'none';
          if (window.dataLayer) {
            window.dataLayer.push({ event: 'newsletter_signup', source: 'exit_popup', email: email });
          }
          setTimeout(closePopup, 3500);
        });
    });

    // ESC tuşu
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
